export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
          联系我们
        </h2>
        <p className="text-sm md:text-base text-foreground-400 mb-8 max-w-lg mx-auto">
          有影片推荐、问题反馈或合作意向？欢迎通过以下方式与我们取得联系
        </p>

        <div className="bg-background-200/40 rounded-lg border border-background-300/30 p-6 md:p-8">
          <div className="flex flex-col sm:flex-row justify-center gap-6 md:gap-12 mb-8">
            <div className="flex items-center gap-3 justify-center">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-500">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-600">电子邮箱</div>
                <div className="text-sm text-foreground-300 font-medium">contact@wuguniang.com</div>
              </div>
            </div>
            <div className="flex items-center gap-3 justify-center">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/15 text-accent-500">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-600">微信公众号</div>
                <div className="text-sm text-foreground-300 font-medium">五姑娘影院</div>
              </div>
            </div>
          </div>

          <p className="text-xs text-foreground-600 mb-6">
            我们会在24小时内回复您的每一条消息
          </p>

          {/* Static contact form appearance - no actual submission */}
          <div className="space-y-4 text-left">
            <input
              type="text"
              placeholder="您的昵称"
              className="w-full px-4 py-3 bg-background-300/40 border border-background-300/40 rounded-md text-sm text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/40 cursor-text"
              disabled
            />
            <input
              type="email"
              placeholder="您的邮箱"
              className="w-full px-4 py-3 bg-background-300/40 border border-background-300/40 rounded-md text-sm text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/40 cursor-text"
              disabled
            />
            <textarea
              placeholder="请描述您的问题或建议..."
              rows={3}
              className="w-full px-4 py-3 bg-background-300/40 border border-background-300/40 rounded-md text-sm text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/40 resize-none cursor-text"
              disabled
            />
            <button
              className="w-full py-3 bg-primary-500/40 text-foreground-300 rounded-md text-sm font-medium cursor-not-allowed whitespace-nowrap"
              disabled
            >
              提交留言（功能开发中）
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}